import dayjs from 'dayjs';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export default async function saveSalesAgents(lotId, salesAgents) {
	var oldValues;

	await firebaseRef
		.ref('/kavtek_clients/' + projectCode + '/lots/' + lotId)
		.once('value', (snapshot) => {
			oldValues = {
				salesAgent: snapshot.val()?.salesAgent,
			};
		})
		.then(() => {
			console.log('oldValues', oldValues);
		});

	var timestampRef = firebaseRef.ref('/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation');

	var lotRef = firebaseRef.ref('/kavtek_clients/' + projectCode + '/lots/' + lotId);

	await lotRef
		.update({
			salesAgent: JSON.parse(salesAgents),
		})
		.then(() => {
			//setting the time stamps

			var timestamp = timestampRef.push();
			console.log('salesAgentsaasada', JSON.parse(salesAgents));

			timestamp.set({
				timestamp: Date.now(),
				value: 'salesAgent',
				oldValue: oldValues.salesAgent ? oldValues.salesAgent : '',
				newValue: salesAgents ? JSON.parse(salesAgents) : '',
				lotId: lotId,
			});
		});
}
